export default "__VITE_ASSET__DBcBAOpX__"